import React from "react";
import LegalLayout from "./LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund Policy" effectiveDate="February 1, 2026">
      <h2>Home Buying Pass — $29.99 one time, 90 days, no auto-renewal</h2>
      <p>The Home Buying Pass is a one-time payment for 90 days of premium Home Cost Path access. It does not automatically renew and no recurring charges are made.</p>

      <h2>Refund window</h2>
      <p>If Home Cost Path is not what you expected, request a refund within <b>7 days of purchase</b>, provided you have not generated more than one shareable report or PDF export. To request a refund, email <a href="mailto:support@homecostpath.com">support@homecostpath.com</a> from the email address associated with the purchase and include the Stripe receipt or your account email.</p>

      <h2>After 7 days</h2>
      <p>Refunds after 7 days are at our discretion and generally not granted for change of mind. If you believe you were charged in error, please contact us — we handle billing errors and duplicate charges promptly.</p>

      <h2>How refunds are issued</h2>
      <p>Approved refunds are issued back to the original Stripe payment method. Refunds typically appear on your statement within 5–10 business days. Once refunded, your premium features revert to the Free plan; your saved homes and worksheet data are preserved.</p>

      <h2>Chargebacks</h2>
      <p>Please contact us before filing a chargeback. We can almost always resolve billing issues faster than the card-network dispute process, and initiating a chargeback for a legitimate purchase may result in your account being suspended.</p>

      <h2>Contact</h2>
      <p><a href="mailto:support@homecostpath.com">support@homecostpath.com</a></p>
    </LegalLayout>
  );
}
